import { render } from "./menuBut.vue?vue&type=template&id=0229ea56&scoped=true"
import script from "./menuBut.vue?vue&type=script&lang=js"
export * from "./menuBut.vue?vue&type=script&lang=js"

import "./menuBut.vue?vue&type=style&index=0&id=0229ea56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0229ea56"]])

export default __exports__